import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { FileSpreadsheet, Download, ArrowRight, ListChecks } from 'lucide-react';
import { IMPORT_FIELDS } from '../../lib/bulkImportFields';

export function WelcomeStep({ onDownloadTemplate, onNext, fields = IMPORT_FIELDS, label = 'Products', kind = 'products' }) {
  const optionalFields = fields.filter(f => !f.required);
  return (
    <div className="space-y-6" data-testid="welcome-step">
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            <ListChecks className="h-4 w-4 text-primary" /> What you'll need
          </CardTitle>
          <CardDescription>
            {label} · CSV, XLSX or XLS · one sheet per import · up to 5,000 rows
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-2 text-sm">
            {fields.filter(f => f.required).map(f => <div key={f.key} className="flex items-center gap-2 p-2 bg-primary/5 rounded" data-testid={`required-field-${f.key}`}>
              <Badge className="text-[10px]">Required</Badge>
              <span>{f.label}</span>
            </div>)}
          </div>
          {kind === 'patients' && <p className="text-sm text-muted-foreground" data-testid="patient-migration-scope">Local pharmacy records only. No portal accounts, identity verification, marketing consent or prescription history will be created. Existing allergies are retained on update.</p>}
          <details className="text-sm" data-testid="migration-field-reference">
            <summary className="cursor-pointer font-medium text-muted-foreground hover:text-foreground" data-testid="migration-field-reference-toggle">
              See all {optionalFields.length} optional fields DutiLyne can also import
            </summary>
            <div className="grid sm:grid-cols-2 gap-2 mt-3">
              {optionalFields.map((f) => (
                <div key={f.key} className="flex flex-wrap items-center gap-2 p-2 bg-muted/50 rounded text-xs" data-testid={`optional-field-${f.key}`}>
                  <Badge variant="outline" className="text-[10px] shrink-0">Optional</Badge>
                  <span className="font-medium">{f.label}</span>
                  <span className="text-muted-foreground ml-auto text-right">{f.hint}</span>
                </div>
              ))}
            </div>
          </details>
        </CardContent>
      </Card>

      <Card data-testid="welcome-template-card">
        <CardContent className="p-4 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
              <FileSpreadsheet className="h-5 w-5 text-primary" />
            </div>
            <div>
              <p className="text-sm font-semibold">Not sure where to start?</p>
              <p className="text-xs text-muted-foreground">CSV template with clearly labeled sample records</p>
            </div>
          </div>
          <Button variant="outline" onClick={onDownloadTemplate} className="gap-1.5 shrink-0" data-testid="download-template-btn">
            <Download className="h-4 w-4" /> Template
          </Button>
        </CardContent>
      </Card>

      <div className="flex justify-end">
        <Button className="gap-1.5" onClick={onNext} data-testid="welcome-next-btn">
          I have my file ready <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
